
export const navstore = {
  namespaced: true,

  state: {
    NavMenuExpanded: true,
    NavMenuTrigger: 0,

    CurrentNode: null,
    BrokenPermission: false,
    BrokenPermissionText: null,

    HeaderHasSubmenu: false,
    ContentContainerHeight: 0,
  },

  mutations: {
    INIT_NAV_EXTENDED(state) {
      state.NavMenuExpanded = true;
    },
    INCREMENT_NAV_TRIGGER(state) {
      state.NavMenuTrigger++;
      state.NavMenuExpanded = !state.NavMenuExpanded;
    },

    SET_CURRENT_NODE(state, newnode) {
      state.CurrentNode = newnode;
    },

    SET_BROKEN_PERMIT(state, bool) {
      state.BrokenPermission = bool;
    },
    SET_BROKEN_PERMIT_TEXT(state, string) {
      state.BrokenPermissionText = string.replace("/", "'s permission for ");
    },

    SET_HEADER_HAS_SUBMENU(state, bool) {
      state.HeaderHasSubmenu = bool;
    },

    SET_CONTENT_CONTAINER_HEIGHT(state, height) {
      state.ContentContainerHeight = height;
    },
  },

  actions: {
    initiateNavMenuExtended({ commit }) {
      commit("INIT_NAV_EXTENDED");
    },
    triggerNavMenu({ commit }) {
      commit("INCREMENT_NAV_TRIGGER");
    },

    setCurrentNode({ commit }, newnode) {
      commit("SET_CURRENT_NODE", newnode);
    },

    setBrokenPermission({ state, commit, dispatch }, bool) {
      if (bool) {
        const permissiontext = state.CurrentNode && state.CurrentNode.permission ? state.CurrentNode.permission : '';
        dispatch('setBrokenPermissionText', permissiontext)
      }
      commit("SET_BROKEN_PERMIT", bool);
    },
    setBrokenPermissionText({ commit }, string) {
      commit("SET_BROKEN_PERMIT_TEXT", string);
    },

    setHeaderHasSubmenu({ commit }, bool) {
      commit("SET_HEADER_HAS_SUBMENU", bool);
    },

    setContentContainerHeight({ commit }, height) {
      commit("SET_CONTENT_CONTAINER_HEIGHT", height);
    },
  },

  getters: {
    Extended: state => {
      return state.NavMenuExpanded;
    },

    ExtendedSubmenu: state => {
      return state.SubMenuExpanded;
    },

    BrokenPermission: state => {
      return state.BrokenPermission;
    },

    BrokenPermitText: state => {
      return state.BrokenPermissionText;
    },

    CurrentNode: state => {
      return state.CurrentNode;
    },

    HeaderHasSubmenu: state => {
      return state.HeaderHasSubmenu;
    },

    ContentContainerHeight: state => {
      return state.ContentContainerHeight;
    },
  },
};
